import { Box, Button, styled } from "@mui/material";
import React, { useContext } from "react";
import { usePermissions } from "context/PermissionsContext";
import { SettingContext, useSettingContext } from "context/SettingContext";
import { useLocation, useNavigate } from "react-router-dom";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { actionTypeToRight } from "features/Setting/Synchronize/utils/actionTypeToNameRight";
 
const SyncButton = ({ location }) => {
  const navigate = useNavigate();
  const { setSyncModal, setRevertAllModal, syncButtonName, setSyncButton, setMissingImagesModal } = useContext(SettingContext);
  const permission = usePermissions();
  const { revertPermission, setRevertPermission } = useSettingContext();
 
  const RevertAccess = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sync", permission), "Revert Changes"), "edit");
  const syncButtonAccess = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sync", permission), actionTypeToRight(syncButtonName)), "edit");
  const mainSyncAccess = hasAccessPage(findSpecificPage("Sync", permission), "edit");
  setRevertPermission(RevertAccess);
 
  const handleClick = () => {
    setSyncModal(true);
  };
 
  const handleRevertClick = () => {
    setRevertAllModal(true);
  };
 
  const handleUnrestrictClick = () => {
    let state = {
      ...location.state,
      innerChnages: true,
      backPath: location.pathname,
      isRestricted: true,
      updateCatagory: "RestrictDesign",
    };
    navigate(location.pathname, { state });
    // setRestrictBtn(false);
    setSyncButton(false);
  };
 
  const StyledButton = styled(Button)(({ theme, variant, disabled }) => ({
    width: "fit",
    fontFamily: "karla",
    fontWeight: 400,
    fontSize: "16.8px",
    lineHeight: "21.04px",
    height: "41px",
    borderRadius: "5px",
    color: "#FFF",
    border: `1px solid #fff`,
    textTransform: "none",
    backgroundColor: "transparent",
    whiteSpace: "nowrap",
 
    "&:hover": {
      backgroundColor: "#fff",
      color: "#000",
    },
  }));

  const isUploadButton = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Missing Images"), "upload_image");
  const showExportDesignInImport = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Design Import"), "Import_export_design");
  const showExportDesignInUpadte = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Design Update"), "Update_export_design");
  const showUnrestictButton = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Restricted Designs"), "unrestict");
  return (
    <div className="child-header-sort">
      {!syncButtonName ? (
        // <Box>{mainSyncAccess && <StyledButton onClick={() => handleClick()}>Sync all</StyledButton>}</Box>
        <Box>{false && <StyledButton onClick={() => handleClick()}>Sync all</StyledButton>}</Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            gap: "32px",
          }}
        >
          {/* {actionTypeToRight(syncButtonName) == "Make Type" && syncButtonAccess && <StyledButton onClick={() => {}}>Sync Make Type</StyledButton>}
          {actionTypeToRight(syncButtonName) == "Sets" && <StyledButton onClick={() => {}}>Sync Sets</StyledButton>}
          {actionTypeToRight(syncButtonName) == "Collection" && <StyledButton onClick={() => {}}>Sync Collection</StyledButton>}
          {actionTypeToRight(syncButtonName) == "Sub-Category" && syncButtonAccess && <StyledButton onClick={() => {}}>Sync Sub - Category</StyledButton>} */}
          {/* {actionTypeToRight(syncButtonName) == "Design Restriction" && syncButtonAccess && <StyledButton onClick={() => {}}>Sync Restrict Design</StyledButton>}
          {actionTypeToRight(syncButtonName) == "Design Class" && <StyledButton onClick={() => {}}>Sync Design Class</StyledButton>}  */}
          {showUnrestictButton && syncButtonName == "unrestrict" && <StyledButton onClick={() => handleUnrestrictClick()}>Unrestrict</StyledButton>}
          {(showExportDesignInImport || showExportDesignInUpadte) && syncButtonName == "exportDesign" && (
            <StyledButton
              onClick={() => {
                alert("Clicked");
              }}
            >
              Export Design
            </StyledButton>
          )}
          {/* {!["unrestrict", "exportDesign","missing-images"].includes(syncButtonName) && revertPermission && <StyledButton onClick={() => handleRevertClick()}>Revert all</StyledButton>} */}

          {isUploadButton && syncButtonName === "missing-images" && <StyledButton onClick={() => setMissingImagesModal(true)}>Upload</StyledButton>}
        </Box>
      )}
    </div>
  );
};
 
export default SyncButton;